export const CREDIT: string = "Credit";
export const TELNET: string = "Telnet";
export const CUSTOMER_MANAGER: string = "CustomerManager";
export const PRICING_TEAM: string = "PricingTeam";
export const SUPPORT: string = "Support";
export const LOYALTY_MARKETING: string = "LoyaltyMarketing";
